import React from 'react';
import { Flex, Tag, Typography, theme } from 'antd';

const STRINGS = {
  heading: (email: string) => `Domains in ${email}`,
  connected: 'Connected',
};

type Props = {
  email: string;
};

// The status is always "Connected": the wizard reaches the picker straight
// from a fresh Google sign-in, and `GscSettings` sends a broken connection to
// `GscSettingsReconnectNeeded` before this ever mounts.
function GscPickerAccountLine({ email }: Props) {
  const { token } = theme.useToken();

  return (
    <Flex align="center" gap={token.marginXS} wrap>
      <Typography.Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
        {STRINGS.heading(email)}
      </Typography.Text>
      <Tag color="success" style={{ margin: 0 }}>
        {STRINGS.connected}
      </Tag>
    </Flex>
  );
}

export default GscPickerAccountLine;
